// Node Tiptap: digitar `/nome` em linha vazia cria child-page node clicável.
// Fluxo: o input rule cria o node com `pendingTitle`; a página que mostra o editor
// observa updates e dispara API call para criar `documents{parentId, title}`.

import { Node, mergeAttributes } from '@tiptap/core';

export interface SlashChildPageAttrs {
  documentId: string | null;
  title: string;
  pending: boolean;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    slashChildPage: {
      insertChildPage: (attrs: SlashChildPageAttrs) => ReturnType;
    };
  }
}

export const SlashChildPage = Node.create({
  name: 'slashChildPage',
  group: 'inline',
  inline: true,
  atom: true,
  draggable: false,
  selectable: true,

  addAttributes() {
    return {
      documentId: { default: null },
      title: { default: '' },
      pending: { default: true },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-child-page]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        'data-child-page': '',
        class: 'child-page-chip',
      }),
      `/${HTMLAttributes.title}`,
    ];
  },

  addInputRules() {
    return [
      {
        // Linha vazia, /palavra, espaço final.
        find: /^\/([\w\-áéíóúãâêôç]{2,40})\s$/,
        handler: ({ range, match, commands }) => {
          const title = match[1]?.trim();
          if (!title) return null;
          commands.deleteRange(range);
          commands.insertContent({
            type: 'slashChildPage',
            attrs: { documentId: null, title, pending: true },
          });
          return null;
        },
      },
    ];
  },

  addCommands() {
    return {
      insertChildPage:
        (attrs) =>
        ({ commands }) =>
          commands.insertContent({ type: 'slashChildPage', attrs }),
    };
  },
});
